<template>
  <section class="carousel section">
    <div class="container">
      <div class="section-header" data-aos="fade-up">
      </div>
      
      <div class="carousel-container" data-aos="fade-up">
        <div class="carousel-wrapper">
          <div 
            class="carousel-track" 
            :style="{ transform: `translateX(-${currentSlide * 100}%)` }"
          >
            <div 
              v-for="(slide, index) in slides" 
              :key="index" 
              class="carousel-slide"
            >
              <div class="slide-content">
                <div class="slide-image">
                  <img v-if="slide.image" :src="slide.image" :alt="slide.title" />
                  <div v-else class="image-placeholder">
                    <div class="placeholder-content">
                      <h3>{{ slide.title }}</h3>
                      <p>{{ slide.description }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <button class="carousel-btn prev" @click="prevSlide" :disabled="currentSlide === 0">
          ❮
        </button>
        <button class="carousel-btn next" @click="nextSlide" :disabled="currentSlide === slides.length - 1">
          ❯
        </button>
        
        <div class="carousel-dots">
          <button 
            v-for="(slide, index) in slides" 
            :key="index"
            class="dot" 
            :class="{ active: currentSlide === index }"
            @click="goToSlide(index)"
          ></button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'

export default {
  name: 'PhotoCarousel',
  setup() {
    const currentSlide = ref(0)
    let autoplayInterval = null
    
    const slides = [
      {
        title: 'Instalacja Kotła Viessmann',
        description: 'Profesjonalna instalacja w domu jednorodzinnym',
        image: require('@/assets/Bez tytułu.png')
      },
      {
        title: 'Serwis Kotła Przemysłowego',
        description: 'Kompleksowy przegląd i naprawa',
        image: require('@/assets/vigas2.png')
      },
      {
        title: 'Montaż Pompy Ciepła',
        description: 'Ekologiczne rozwiązanie grzewcze',
        image: require('@/assets/vigas 3.png')
      },
      {
        title: 'System Smart Home',
        description: 'Inteligentne sterowanie ogrzewaniem'
      }
    ]
    
    const nextSlide = () => {
      if (currentSlide.value < slides.length - 1) {
        currentSlide.value++
      } else {
        currentSlide.value = 0
      }
    }
    
    const prevSlide = () => {
      if (currentSlide.value > 0) {
        currentSlide.value--
      } else {
        currentSlide.value = slides.length - 1
      }
    }
    
    const goToSlide = (index) => {
      currentSlide.value = index
    }
    
    const startAutoplay = () => {
      autoplayInterval = setInterval(nextSlide, 4000)
    }
    
    const stopAutoplay = () => {
      if (autoplayInterval) {
        clearInterval(autoplayInterval)
      }
    }
    
    onMounted(() => {
      startAutoplay()
    })
    
    onUnmounted(() => {
      stopAutoplay()
    })
    
    return {
      currentSlide,
      slides,
      nextSlide,
      prevSlide,
      goToSlide
    }
  }
}
</script>

<style lang="scss" scoped>
.carousel {
  background: white;
}

.section-header {
  text-align: center;
  margin-bottom: 60px;
  
  h2 {
    font-size: 2.5rem;
    color: #333;
    margin-bottom: 15px;
  }
  
  .section-line {
    width: 60px;
    height: 4px;
    background: linear-gradient(135deg, #FF6B35, #FFD93D);
    margin: 0 auto 20px;
    border-radius: 2px;
  }
  
  p {
    font-size: 1.1rem;
    color: #666;
  }
}

.carousel-container {
  position: relative;
  max-width: 800px;
  margin: 0 auto;
}

.carousel-wrapper {
  overflow: hidden;
  border-radius: 15px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
}

.carousel-track {
  display: flex;
  transition: transform 0.5s ease;
}

.carousel-slide {
  min-width: 100%;
  height: 400px;
}

.slide-content {
  width: 100%;
  height: 100%;
}

.slide-image {
  width: 100%;
  height: 100%;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .image-placeholder {
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    text-align: center;
    
    .placeholder-content {
      h3 {
        font-size: 2rem;
        margin-bottom: 15px;
        color: white;
      }
      
      p {
        font-size: 1.1rem;
        opacity: 0.9;
        color: white;
      }
    }
  }
}

.carousel-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.9);
  border: none;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  font-size: 1.5rem;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 10;
  
  &:hover {
    background: white;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  
  &.prev {
    left: 20px;
  }
  
  &.next {
    right: 20px;
  }
}

.carousel-dots {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 30px;
  
  .dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    border: none;
    background: #ddd;
    cursor: pointer;
    transition: all 0.3s ease;
    
    &.active {
      background: #FF6B35;
      transform: scale(1.2);
    }
    
    &:hover {
      background: #FF6B35;
    }
  }
}

@media (max-width: 768px) {
  .carousel-slide {
    height: 300px;
  }
  
  .carousel-btn {
    width: 40px;
    height: 40px;
    font-size: 1.2rem;
    
    &.prev {
      left: 10px;
    }
    
    &.next {
      right: 10px;
    }
  }
  
  .slide-image .image-placeholder .placeholder-content h3 {
    font-size: 1.5rem;
  }
  
  .section-header h2 {
    font-size: 2rem;
  }
}
</style>